import { Euler, PerspectiveCamera } from 'three';
import { CAMERA } from '../config/settings';
import { Updatable } from '../core/types';
import { Player } from './Player';

/**
 * Drives the camera from the player's state: eye position, look rotation,
 * subtle head-bob while running, and a speed-based FOV boost for a sense of
 * velocity. Read-only with respect to the player.
 */
export class PlayerCamera implements Updatable {
  private bobPhase = 0;
  private readonly euler = new Euler(0, 0, 0, 'YXZ');

  constructor(
    private readonly camera: PerspectiveCamera,
    private readonly player: Player,
  ) {}

  update(dt: number): void {
    this.camera.position.copy(this.player.position);
    this.camera.position.y += this.player.eyeHeight;

    const speedH = this.player.horizontalSpeed;
    if (this.player.grounded && speedH > 0.1) {
      this.bobPhase += dt * speedH * 1.1;
      this.camera.position.y += Math.sin(this.bobPhase) * CAMERA.BOB_AMPLITUDE;
    }

    this.euler.set(this.player.pitch, this.player.yaw, 0);
    this.camera.quaternion.setFromEuler(this.euler);

    const targetFov = CAMERA.BASE_FOV + Math.min(CAMERA.MAX_FOV_BOOST, this.player.velocity.length() * CAMERA.FOV_SPEED_FACTOR);
    this.camera.fov += (targetFov - this.camera.fov) * Math.min(1, dt * CAMERA.FOV_LERP);
    this.camera.updateProjectionMatrix();
  }
}
